export const PatientRepositoryToken = Symbol('PatientRepository');
export const AnonymizationEvaluatorToken = Symbol('AnonymizationEvaluator');
